import isEmpty from "./isEmpty";

/**
 * Build query from provided params
 *
 * @param {Object} params - build query string from provided params, ex. {page: 1, perPage: 3}
 * @returns {string} query string
 */
export default (params) => {
  if (!isEmpty(params)) {
    return Object.keys(params)
      .reduce(
        (query, currentParam) =>
          params[currentParam]
            ? `${query}${currentParam}=${params[currentParam]}&`
            : query,
        "?"
      )
      .replace(/&$/g, "")
      .replace(/^\?$/g, "");
  } else {
    return "";
  }
};
